import { useState } from "react";
import { Gift, Copy, Check, X } from "lucide-react";
import { toast } from "sonner";
import { getEffectiveLang } from "@/lib/i18n";

const CODE = "NUXXUM50";
const KEY = "nuxxum_promo_banner_dismissed";

const COPY = {
  es: {
    tag: "Oferta de lanzamiento",
    text: "50% de descuento en Premium durante 3 meses con el código",
    copy: "Copiar",
    copied: "¡Código copiado!",
    close: "Cerrar aviso",
  },
  en: {
    tag: "Launch offer",
    text: "50% off Premium for 3 months with code",
    copy: "Copy",
    copied: "Code copied!",
    close: "Dismiss",
  },
};

export const LaunchPromoBanner = () => {
  const [hidden, setHidden] = useState(() => localStorage.getItem(KEY) === "1");
  const [copied, setCopied] = useState(false);
  const c = COPY[getEffectiveLang(null) === "en" ? "en" : "es"];
  if (hidden) return null;

  const copyCode = async () => {
    try {
      await navigator.clipboard.writeText(CODE);
    } catch {
      // clipboard unavailable: user can still read the code
    }
    setCopied(true);
    toast.success(c.copied);
    setTimeout(() => setCopied(false), 2000);
  };

  const dismiss = () => {
    localStorage.setItem(KEY, "1");
    setHidden(true);
  };

  return (
    <div data-testid="launch-promo-banner"
      className="relative z-10 bg-gradient-to-r from-[#5B52EB] via-[#6E63F7] to-[#7AD7C4] text-white animate-fade-up">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 min-h-11 py-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 text-sm">
        <span className="inline-flex items-center gap-1.5 font-bold uppercase tracking-[0.15em] text-[11px] bg-white/20 rounded-full px-2.5 py-0.5">
          <Gift size={13} /> {c.tag}
        </span>
        <span className="font-medium text-center">{c.text}</span>
        <button type="button" onClick={copyCode} data-testid="promo-code-copy-btn" title={c.copy}
          className="inline-flex items-center gap-1.5 font-mono font-extrabold tracking-widest bg-[#171927] hover:bg-black rounded-md px-3 py-1 transition-colors">
          {CODE} {copied ? <Check size={14} className="text-[#7AD7C4]" /> : <Copy size={14} className="opacity-70" />}
        </button>
        <button type="button" onClick={dismiss} data-testid="promo-banner-close-btn" aria-label={c.close}
          className="absolute right-2 top-1/2 -translate-y-1/2 sm:right-4 h-7 w-7 rounded-full hover:bg-white/20 flex items-center justify-center transition-colors">
          <X size={15} />
        </button>
      </div>
    </div>
  );
};
